import React from "react";
import { FaAddressBook, FaPlus, FaRegArrowAltCircleLeft, FaSync, FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import { SettingGeneralProvider } from "../../../context/settingGeneralContext";
import HeaderReusable from "../../Global/HeaderContent";

export default function HeaderNurse({
  isTabletOrMobile,
  title = "List Nurse",
  query,
  setQuery,
  limit,
  setLimit,
  searchData,
  buttonRefresh,
  viewModalAdd,
  handleModalRelationPatient,
  showCustomButtonRelationPatient
}) {
  return (
    <SettingGeneralProvider>
      <HeaderNurseContent
        isTabletOrMobile={isTabletOrMobile}
        title={title}
        query={query}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        viewModalAdd={viewModalAdd}
        buttonRefresh={buttonRefresh}
        searchData={searchData}
        handleModalRelationPatient={handleModalRelationPatient}
        showCustomButtonRelationPatient={showCustomButtonRelationPatient}
      />
    </SettingGeneralProvider>
  )
}

function HeaderNurseContent({
  isTabletOrMobile,
  title,
  query,
  setQuery,
  limit,
  setLimit,
  searchData,
  buttonRefresh,
  viewModalAdd,
  handleModalRelationPatient,
  showCustomButtonRelationPatient
}) {
  return (
    <>
      <HeaderReusable
        title={title}
        icon={FaAddressBook}
        isTabletOrMobile={false}
        query={query}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        searchData={searchData}
        onAdd={viewModalAdd}
        showAddButton={false}
        onRefresh={buttonRefresh}
        showRefreshButton={true}
        handleModalRelationPatient={handleModalRelationPatient}
        showCustomButtonRelationPatient={showCustomButtonRelationPatient}
      />
    </>
  )
}
